/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');
	}

	fixJudgeMeBadges() {
		// Refresh Judge.me badges after AJAX load
		if (window.jdgm && typeof window.jdgm.refreshBadges === 'function') {
			window.jdgm.refreshBadges();
		}

		this.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
			const rating = parseFloat(badge.getAttribute('data-average-rating'));
			const widget = badge.closest('.jdgm-widget.jdgm-preview-badge');
			const text = badge.querySelector('.jdgm-prev-badge__text');

			// Hide whole widget if rating is 0
			if (!rating || rating === 0) {
				if (widget) {
					widget.style.display = 'none';
				}
				return;
			}

			// Show only rating number
			if (text) {
				text.textContent = rating.toFixed(2);
			}

			badge.style.display = 'inline-flex';
		});
	}

	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;

				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {

					this.innerHTML = recommendations.innerHTML;

					// Fix Judge.me badges after recommendations load
					setTimeout(() => {
						this.fixJudgeMeBadges();
					}, 300);

					setTimeout(() => {
						this.fixJudgeMeBadges();
					}, 1000);

					if (this.parent) {
						this.parent.classList.add('product-recommendations--full');

						if (OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
							this.parent.classList.add('active');
						}
					}
				}

				this.classList.add('product-recommendations--loaded');
			})
			.catch(e => {
				console.error(e);
			});
	}

	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);